export default __webpack_public_path__ + "static/media/326.74fcb169.png";